import { TScudMappingMode, TScudMatchStatus } from '@/shared/types/scudMapping.types';

export const SCUD_STATUS: Record<TScudMatchStatus, { label: string; color: string }> = {
	0: { label: 'Не сопоставлен', color: 'orange' },
	1: { label: 'Сопоставлен', color: 'green' },
	2: { label: 'Неоднозначно', color: 'red' },
	3: { label: 'Сопоставление не требуется', color: 'violet' },
};

export const SCUD_STATUS_OPTIONS = ([0, 1, 2, 3] as TScudMatchStatus[]).map((status) => ({
	value: `${status}`,
	label: SCUD_STATUS[status].label,
}));

export const SCUD_MODE_LABELS: Record<TScudMappingMode, string> = {
	unprocessed: 'Необработанные',
	processed: 'Обработанные',
	all: 'Все',
};

export const SCUD_PAGE_SIZES = ['25', '50', '100'];

/** Больше записей за один запрос списка API не отдаёт */
export const SCUD_MAX_LIMIT = 500;

/** Ограничения бэкенда (ScudMappingRules) */
export const SCUD_COMMENT_MAX_LENGTH = 1000;
export const SCUD_SEARCH_MIN_LENGTH = 3;
export const SCUD_REASON_NAME_MAX_LENGTH = 200;

/** Кто изменил запись в журнале: служебные авторы показываются словами */
export const SCUD_AUDIT_AUTHORS: Record<string, string> = {
	etl: 'Загрузка',
	'перенос при запуске': 'Перенос при запуске',
};

/** Миграции пишут в журнал автора «alembic <ревизия>» */
export const SCUD_AUDIT_ALEMBIC_PREFIX = 'alembic ';
export const SCUD_AUDIT_ALEMBIC_AUTHOR = 'Обновление базы при запуске';

/** 502/503 от прокси приходят без тела ServiceErrorResponse */
export const SCUD_SERVICE_UNAVAILABLE_TEXT = 'Сервис сопоставления пропусков СКУД недоступен';

export const SCUD_AUDIT_ACTIONS: Record<string, string> = {
	CREATE: 'Запись создана',
	UPDATE: 'Изменение',
	DELETE: 'Запись удалена',
};

/** Подписи полей журнала scud_audit_log; поля, которых здесь нет, выводятся по имени */
export const SCUD_AUDIT_FIELDS: Record<string, string> = {
	match_status: 'Статус',
	person_id_federation: 'Сотрудник в «Федерации» (id)',
	full_name_federation: 'Сотрудник в «Федерации»',
	reason_id: 'Причина',
	guard_comment: 'Комментарий',
	guard_confirmed: 'Подтверждено',
	confirmed_by: 'Подтвердил',
	confirmed_at: 'Дата подтверждения',
	matched_by: 'Кем сопоставлен',
	location: 'Локация',
	skud: 'СКУД',
	person_id_skud: 'Пропуск',
	full_name_skud: 'Сотрудник по СКУД',
	tabnumber: 'Табельный номер',
	tab_number: 'Табельный номер',
	comment: 'Комментарий',
};

export const SCUD_MATCHED_BY: Record<string, string> = {
	etl: 'загрузка',
	guard: 'охрана',
};

export const SCUD_EMPTY = '—';
